<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{publication.title}}</h2>
                    <ul>
                        <li><a routerLink="/">Accueil</a></li>
                        <li>Détails</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="image" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="image" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="image" /></div>
    </div>
</div>

<section class="single-blog-area pt-100 pb-100">
    <div class="container" *ngIf="!loading && publication; else loadingTpl">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">

                    <!-- Carousel bannière -->
                    <div id="bannerCarousel" class="article-image carousel slide banner-image" data-bs-ride="carousel" *ngIf="images.length || mainBlobUrl; else noImageTpl">
                        <div class="carousel-inner rounded">

                            <!-- images directes -->
                            <div
                                *ngFor="let img of images; index as i"
                                class="carousel-item"
                                [class.active]="i === 0"
                            >
                                <img [src]="img" class="d-block w-100 banner-img" [alt]="'Image ' + (i + 1)" />
                            </div>

                            <!-- fallback blob unique -->
                            <div class="carousel-item active" *ngIf="!images.length && mainBlobUrl">
                                <img [src]="mainBlobUrl" class="d-block w-100 banner-img" alt="Image principale" />
                            </div>
                        </div>

                        <button class="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        </button>
                    </div>

                    <ng-template #noImageTpl>
                        <div class="rounded overflow-hidden shadow-sm">
                            <span>Aucune image disponible.</span>
                        </div>
                    </ng-template>

                    <div class="article-content mt-4">
                        <div class="entry-meta">
                            <ul>
                                <li>
                  <span>
                    <i class="fa fa-calendar me-1"></i>
                      {{ publication.date | date: 'd MMMM y' }}
                  </span>
                                </li>
                                <li *ngIf="publication.createdBy">
                                    <span><i class="fa fa-user me-1"></i> {{ publication.createdBy }}</span>
                                </li>
                                <li>
                                    <span><i class="fa fa-tag me-1"></i> {{ publication.type }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="prose mt-3" [innerHTML]="publication.htmlText | breakableHtml"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template #loadingTpl>
        <div class="container"><p class="text-center text-muted py-5">Chargement…</p></div>
    </ng-template>
</section>

<app-subscribe></app-subscribe>
